<template lang="pug">
.card.d-flex.flex-column.flex-md-row(:class="{ select }")
  .image_container.d-flex.flex-grow-1.d-md-block.justify-content-between.align-items-center
    h5 {{ item.area02_PackageList_Title }}
    img.bg_default_gray.flex-shrink-0(:src="item.area02_PackageList_Image")
  .content.i_ml_2.i_ml_md_3.i_ml_sm_0.i_mt_sm_4
    p {{ item.area02_PackageList_SubTitle }}
</template>

<script>
export default {
  name: "Card",
  props: {
    item: Object,
    select: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product_combo/card";
</style>
